// import React, { useState } from "react";
// import { MdCloudUpload } from "react-icons/md";
// import { addCoin } from "../../api/coinsApi";
// import "./AddCoinModal.css";

// const AddCoinModal = ({ onClose, onAdd }) => {
//   const [coinValue, setCoinValue] = useState("");
//   const [price, setPrice] = useState("");
//   const [imageFile, setImageFile] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const handleSubmit = async () => {
//     if (!coinValue || !price || !imageFile) {
//       alert("All fields are required");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("coinValue", coinValue);
//     formData.append("price", price);
//     formData.append("thumbnail", imageFile);

//     try {
//       setLoading(true);
//       const newCoin = await addCoin(formData);
//       onAdd(newCoin);

//       setCoinValue("");
//       setPrice("");
//       setImageFile(null);
//       onClose();
//     } catch (error) {
//       console.error("Add coin error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="add-coin-overlay">
//       <div className="add-coin-modal">
//         <h2 className="add-coin-title">Add Coins</h2>

//         <input
//           type="number"
//           placeholder="Enter Amount"
//           value={coinValue}
//           onChange={(e) => setCoinValue(e.target.value)}
//           className="add-coin-input"
//         />

//         <input
//           type="number"
//           placeholder="Mark price"
//           value={price}
//           onChange={(e) => setPrice(e.target.value)}
//           className="add-coin-input"
//         />

//         <div className="upload-wrapper">
//           <input
//             type="file"
//             id="coinImage"
//             className="upload-input"
//             accept="image/*"
//             onChange={(e) => setImageFile(e.target.files[0])}
//           />
//           <label htmlFor="coinImage" className="upload-label">
//             <span>
//               {imageFile ? imageFile.name : "Upload image"}
//             </span>
//             <MdCloudUpload className="upload-icon" />
//           </label>
//         </div>

//         <div className="modal-actions">
//           <button className="btn-secondary" onClick={onClose}>
//             Back
//           </button>
//           <button
//             className="btn-primary"
//             onClick={handleSubmit}
//             disabled={loading}
//           >
//             {loading ? "Saving..." : "Add Coins"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddCoinModal;

import React, { useState, useEffect } from "react";
import { MdCloudUpload } from "react-icons/md";
import { addCoin, updateCoin } from "../../api/coinsApi";
import "./AddCoinModal.css";

const AddCoinModal = ({ onClose, onAdd, data }) => {
  const [coinValue, setCoinValue] = useState("");
  const [price, setPrice] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data) {
      setCoinValue(data.count || "");
      setPrice(data.price || "");
      setImageFile(data.image || null);
    }
  }, [data]);

  function encodeImageFileAsURL(event) {
    const file = event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = function () {
      const base64String = reader.result;
      console.log("RESULT", reader.result);
      setImageFile(base64String);
    };

    reader.readAsDataURL(file);
  }

  const handleSubmit = async () => {
    if (!coinValue || !price || !imageFile) {
      alert("All fields are required");
      return;
    }

    // const formData = new FormData();
    // formData.append("count", coinValue);
    // formData.append("price", price);
    // formData.append("image", imageFile);

    const payload = {
      image: imageFile,
      price,
      count: coinValue,
    };

    try {
      setLoading(true);
      let response;
      if (data) {
        response = await updateCoin(data._id, payload);
      } else {
        response = await addCoin(payload);
      }

      onAdd(response);

      setCoinValue("");
      setPrice("");
      setImageFile(null);
      onClose();
    } catch (error) {
      console.error("Add coin error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setCoinValue("");
    setImageFile(null);
    setPrice("");
    onClose();
  };

  return (
    <div className="addcoin-backdrop">
      <div className="addcoin-modal">
        <h2 className="addcoin-title">{data ? "Edit Coin" : "Add Coin"}</h2>

        <input
          type="number"
          placeholder="Enter Amount"
          value={coinValue}
          onChange={(e) => setCoinValue(e.target.value)}
          className="addcoin-input"
        />

        <input
          type="number"
          placeholder="Mark price"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          className="addcoin-input"
        />

        <div className="upload-box">
          <input
            type="file"
            id="coinImage"
            className="upload-input"
            accept="image/*"
            // onChange={(e) => setImageFile(e.target.files[0])}
            onChange={encodeImageFileAsURL}
          />

          <label htmlFor="coinImage" className="upload-label">
            <span className="upload-text">
              {/* {imageFile ? imageFile.name : "Upload image"} */}
              {imageFile ? "Image selected" : "Upload image"}
            </span>
            <MdCloudUpload className="upload-icon" />
          </label>
        </div>

        <div className="addcoin-actions">
          <button onClick={handleClose} className="btn-outline">
            Back
          </button>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="btn-primary"
          >
            {/* {loading ? "Saving..." : "Add Coins"} */}
            {loading ? "Saving..." : data ? "Update Coin" : "Add Coins"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddCoinModal;
